export default __webpack_public_path__ + "locales/ja-JP/ChangeEmailDialog.json?hash=76ebf7975c1bcc2eb5f45f9a949f4a77";